import { Capacitor } from '@capacitor/core';

export const isMobileWebBrowser =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
  !Capacitor.isNativePlatform();
